webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(37)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(51),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(56),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {"seller":{"name":"粥品香坊（回龙观）","description":"蜂鸟专送","deliveryTime":38,"score":4.2,"serviceScore":4.1,"foodScore":4.3,"rankRate":69.2,"minPrice":20,"deliveryPrice":4,"ratingCount":24,"sellCount":90,"bulletin":"粥品香坊其烹饪粥料的秘方源于中国千年古法，在融和现代制作工艺，由世界烹饪大师屈浩先生领衔研发。坚守纯天然、零添加的良心品质深得消费者的青睐，发展至今已经成为粥类的引领品牌。是2008年奥运会和2013年园博会指定餐饮服务商。","supports":[{"type":0,"description":"在线支付满28减5"},{"type":1,"description":"VC无限橙果汁全场8折"},{"type":2,"description":"单人精彩套餐"},{"type":3,"description":"该商家支持发票,请下单写好发票抬头"},{"type":4,"description":"已加入“外卖保”计划,食品安全保障"}],"avatar":"http://static.galileo.xiaojukeji.com/static/tms/seller_avatar_256px.jpg","pics":["http://fuss10.elemecdn.com/8/71/c5cf5715740998d5040dda6e66abfjpeg.jpeg?imageView2/1/w/180/h/180","http://fuss10.elemecdn.com/b/6c/75bd250e5ba69868f3b1178afbda3jpeg.jpeg?imageView2/1/w/180/h/180","http://fuss10.elemecdn.com/f/96/3d608c5811bc2d902fc9ab9a5baa7jpeg.jpeg?imageView2/1/w/180/h/180","http://fuss10.elemecdn.com/6/ad/779f8620ff49f701cd4c58f6448b6jpeg.jpeg?imageView2/1/w/180/h/180"],"infos":["该商家支持发票,请下单写好发票抬头","品类:其他菜系,包子粥店","北京市昌平区回龙观西大街龙观置业大厦底商B座102单元1340","营业时间:10:00-20:30"]},"goods":[{"name":"热销榜","type":5,"foods":[{"name":"皮蛋瘦肉粥","price":10,"oldPrice":"","remark":"咸粥","description":"","sellCount":229,"rating":100,"info":"一碗皮蛋瘦肉粥，总是我到粥店时的不二之选。香浓软滑，饱腹暖心，皮蛋的Q弹与瘦肉的滑嫩伴着粥香溢于满口，让人喝这样的一碗粥也觉得心满意足","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"很喜欢的粥","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/c/cd/c12745ed8a5171e13b427dbc39401jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/c/cd/c12745ed8a5171e13b427dbc39401jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"扁豆焖面","price":14,"oldPrice":"","remark":"","description":"","sellCount":188,"rating":96,"ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"info":"","icon":"http://fuss10.elemecdn.com/c/6b/29e3d29b0db63d36f7c500bca31d8jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/c/6b/29e3d29b0db63d36f7c500bca31d8jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"葱花饼","price":10,"oldPrice":"","remark":"","description":"","sellCount":124,"rating":85,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"没啥味道","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":-1,"text":"很一般啊","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/f/28/a51e7b18751bcdf871648a23fd3b4jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/f/28/a51e7b18751bcdf871648a23fd3b4jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"牛肉馅饼","price":14,"oldPrice":"","remark":"","description":"","sellCount":114,"rating":91,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"难吃不推荐","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/d/b9/bcab0e8ad97758e65ae5a62b2664ejpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/d/b9/bcab0e8ad97758e65ae5a62b2664ejpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"招牌猪肉白菜锅贴/10个","price":17,"oldPrice":"","remark":"","description":"","sellCount":101,"rating":78,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"不脆,不好吃","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/7/72/9a580c1462ca1e4d3c07e112bc035jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/7/72/9a580c1462ca1e4d3c07e112bc035jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"南瓜粥","price":9,"oldPrice":"","remark":"甜粥","description":"","sellCount":91,"rating":100,"ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/8/a6/453f65f16b1391942af11511b7a90jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/8/a6/453f65f16b1391942af11511b7a90jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"红豆薏米美肤粥","price":12,"oldPrice":"","remark":"甜粥","description":"","sellCount":86,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/d/22/260bd78ee6ac6051136c5447fe307jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/d/22/260bd78ee6ac6051136c5447fe307jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"八宝酱菜","price":4,"oldPrice":"","remark":"","description":"","sellCount":84,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"红枣山药糙米粥","price":10,"oldPrice":"","remark":"","description":"","sellCount":81,"rating":91,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"糊塌子","price":10,"oldPrice":"","remark":"","description":"","sellCount":80,"rating":93,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/0/05/097a2a59fd2a2292d08067e16380cjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/0/05/097a2a59fd2a2292d08067e16380cjpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"单人精彩套餐","type":2,"foods":[{"name":"红枣山药粥套餐","price":29,"oldPrice":36,"remark":"配菜可备注","description":"红枣山药糙米粥,素材包,爽口莴笋丝,四川泡菜或八宝酱菜,配菜可备注","sellCount":17,"rating":100,"info":"","ratings":[{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/6/72/cb844f0bb60c502c6d5c05e0bddf5jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/6/72/cb844f0bb60c502c6d5c05e0bddf5jpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"冰爽饮品限时特惠","type":1,"foods":[{"name":"VC无限橙果汁","price":8,"oldPrice":10,"remark":"","description":"","sellCount":15,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"还可以","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/e/c6/f348e811772016ae24e968238bcbfjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/e/c6/f348e811772016ae24e968238bcbfjpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"精选热菜","type":-1,"foods":[{"name":"娃娃菜炖豆腐","price":17,"oldPrice":"","remark":"","description":"","sellCount":43,"rating":92,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"菜量还可以,味道还可以","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/d/2d/b1eb45b305635d9dd04ddf157165fjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/d/2d/b1eb45b305635d9dd04ddf157165fjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"手撕包菜","price":16,"oldPrice":"","remark":"","description":"","sellCount":29,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/9/c6/f3bc84468820121112e79583c24efjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/9/c6/f3bc84468820121112e79583c24efjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"香酥黄金鱼/3条","price":11,"oldPrice":"","remark":"","description":"","sellCount":15,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/4/e7/8277a6a2ea0a2e97710290499fc41jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/4/e7/8277a6a2ea0a2e97710290499fc41jpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"爽口凉菜","type":-1,"foods":[{"name":"八宝酱菜","price":4,"oldPrice":"","remark":"","description":"","sellCount":84,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"拍黄瓜","price":9,"oldPrice":"","remark":"","description":"","sellCount":28,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/6/54/f654985b4e185f06eb07f8fa2b2e8jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/6/54/f654985b4e185f06eb07f8fa2b2e8jpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"精选套餐","type":-1,"foods":[{"name":"红豆薏米粥套餐","price":37,"oldPrice":"","remark":"","description":"红豆薏米粥,三鲜干蒸烧卖,拍黄瓜","sellCount":3,"rating":100,"info":"","ratings":[{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/f/49/27f26ed00c025b2200a9ccbb7e67ejpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/f/49/27f26ed00c025b2200a9ccbb7e67ejpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"皮蛋瘦肉粥套餐","price":31,"oldPrice":"","remark":"","description":"","sellCount":12,"rating":100,"info":"","ratings":[{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/8/96/f444a8087f0e940ef264617f9d98ajpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/8/96/f444a8087f0e940ef264617f9d98ajpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"果拼果汁","type":-1,"foods":[{"name":"蜜瓜圣女萝莉杯","price":6,"oldPrice":"","remark":"","description":"","sellCount":1,"rating":"","info":"","ratings":[],"icon":"http://fuss10.elemecdn.com/b/5f/b3b04c259d5ec9fa52e1856ee50dajpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/b/5f/b3b04c259d5ec9fa52e1856ee50dajpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"加多宝","price":6,"oldPrice":"","remark":"","description":"","sellCount":7,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/b/9f/5e6c99c593cf65229225c5661bcdejpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/b/9f/5e6c99c593cf65229225c5661bcdejpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"VC无限橙果汁","price":8,"oldPrice":10,"remark":"","description":"","sellCount":15,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"还可以","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/e/c6/f348e811772016ae24e968238bcbfjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/e/c6/f348e811772016ae24e968238bcbfjpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"小吃主食","type":-1,"foods":[{"name":"扁豆焖面","price":14,"oldPrice":"","remark":"","description":"","sellCount":188,"rating":96,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/c/6b/29e3d29b0db63d36f7c500bca31d8jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/c/6b/29e3d29b0db63d36f7c500bca31d8jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"葱花饼","price":10,"oldPrice":"","remark":"","description":"","sellCount":124,"rating":85,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"没啥味道","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":-1,"text":"很一般啊","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/f/28/a51e7b18751bcdf871648a23fd3b4jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/f/28/a51e7b18751bcdf871648a23fd3b4jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"牛肉馅饼","price":14,"oldPrice":"","remark":"","description":"","sellCount":114,"rating":91,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"难吃不推荐","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/d/b9/bcab0e8ad97758e65ae5a62b2664ejpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/d/b9/bcab0e8ad97758e65ae5a62b2664ejpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"招牌猪肉白菜锅贴/10个","price":17,"oldPrice":"","remark":"","description":"","sellCount":101,"rating":78,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":-1,"text":"不脆,不好吃","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/7/72/9a580c1462ca1e4d3c07e112bc035jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/7/72/9a580c1462ca1e4d3c07e112bc035jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"糊塌子","price":10,"oldPrice":"","remark":"","description":"","sellCount":80,"rating":93,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/0/05/097a2a59fd2a2292d08067e16380cjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/0/05/097a2a59fd2a2292d08067e16380cjpeg.jpeg?imageView2/1/w/750/h/750"}]},{"name":"特色粥品","type":-1,"foods":[{"name":"皮蛋瘦肉粥","price":10,"oldPrice":"","remark":"咸粥","description":"","sellCount":229,"rating":100,"ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"很喜欢的粥","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/c/cd/c12745ed8a5171e13b427dbc39401jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/c/cd/c12745ed8a5171e13b427dbc39401jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"南瓜粥","price":9,"oldPrice":"","remark":"甜粥","description":"","sellCount":91,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/8/a6/453f65f16b1391942af11511b7a90jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/8/a6/453f65f16b1391942af11511b7a90jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"红豆薏米美肤粥","price":12,"oldPrice":"","remark":"甜粥","description":"","sellCount":86,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/d/22/260bd78ee6ac6051136c5447fe307jpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/d/22/260bd78ee6ac6051136c5447fe307jpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"红枣山药糙米粥","price":10,"oldPrice":"","remark":"","description":"","sellCount":81,"rating":91,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/9/b5/469d8854f9a3a03797933fd01398bjpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"鲜蔬菌菇粥","price":11,"oldPrice":"","remark":"咸粥","description":"","sellCount":56,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":""},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/e/a3/5317c68dd618929b6ac05804e429ajpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/e/a3/5317c68dd618929b6ac05804e429ajpeg.jpeg?imageView2/1/w/750/h/750"},{"name":"田园蔬菜粥","price":10,"oldPrice":"","remark":"咸粥","description":"","sellCount":33,"rating":100,"info":"","ratings":[{"username":"3******c","rateTime":1469281964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"2******3","rateTime":1469271264000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"},{"username":"3******b","rateTime":1469261964000,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png"}],"icon":"http://fuss10.elemecdn.com/a/94/7371083792c19df00e546b29e344cjpeg.jpeg?imageView2/1/w/114/h/114","image":"http://fuss10.elemecdn.com/a/94/7371083792c19df00e546b29e344cjpeg.jpeg?imageView2/1/w/750/h/750"}]}],"ratings":[{"username":"3******c","rateTime":1469281964000,"deliveryTime":30,"score":5,"rateType":1,"text":"不错,粥很好喝,我经常吃这一家,非常赞,以后也会常来吃,强烈推荐.","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":["南瓜粥","皮蛋瘦肉粥","扁豆焖面","娃娃菜炖豆腐","牛肉馅饼"]},{"username":"2******3","rateTime":1469271264000,"deliveryTime":"","score":4,"rateType":1,"text":"服务态度不错","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":["扁豆焖面"]},{"username":"3******b","rateTime":1469261964000,"score":3,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"1******c","rateTime":1469261864000,"deliveryTime":20,"score":5,"rateType":1,"text":"良心店铺","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"2******d","rateTime":1469251264000,"deliveryTime":10,"score":4,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"9******0","rateTime":1469241964000,"deliveryTime":70,"score":1,"rateType":-1,"text":"送货速度蜗牛一样","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"d******c","rateTime":1469231964000,"deliveryTime":30,"score":5,"rateType":1,"text":"很喜欢的粥店","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"2******3","rateTime":1469221264000,"deliveryTime":"","score":4,"rateType":1,"text":"量给的还可以","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"3******8","rateTime":1469211964000,"deliveryTime":"","score":3,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"a******a","rateTime":1469201964000,"deliveryTime":"","score":4,"rateType":1,"text":"孩子喜欢吃这家","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":["南瓜粥"]},{"username":"3******3","rateTime":1469191264000,"deliveryTime":"","score":4,"rateType":1,"text":"粥挺好吃的","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"t******b","rateTime":1469181964000,"deliveryTime":"","score":3,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"f******c","rateTime":1469171964000,"deliveryTime":15,"score":5,"rateType":1,"text":"送货速度很快","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"k******3","rateTime":1469161264000,"deliveryTime":"","score":4,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"u******b","rateTime":1469151964000,"deliveryTime":"","score":4,"rateType":1,"text":"下雨天给快递小哥点个赞","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"s******c","rateTime":1469141964000,"deliveryTime":"","score":4,"rateType":1,"text":"好","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"z******3","rateTime":1469131264000,"deliveryTime":"","score":5,"rateType":1,"text":"吃了还想再吃","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"n******b","rateTime":1469121964000,"deliveryTime":"","score":3,"rateType":-1,"text":"发票开的不对","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"m******c","rateTime":1469111964000,"deliveryTime":30,"score":5,"rateType":1,"text":"好吃","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"l******3","rateTime":1469101264000,"deliveryTime":40,"score":5,"rateType":1,"text":"还不错吧","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"3******o","rateTime":1469091964000,"deliveryTime":"","score":2,"rateType":-1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"3******p","rateTime":1469081964000,"deliveryTime":"","score":4,"rateType":1,"text":"很喜欢的粥","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"o******k","rateTime":1469071264000,"deliveryTime":"","score":5,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]},{"username":"k******b","rateTime":1469061964000,"deliveryTime":"","score":4,"rateType":1,"text":"","avatar":"http://static.galileo.xiaojukeji.com/static/tms/default_header.png","recommend":[]}]}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/**
 * Author:shiduobin
 * Create Time:2017-08-24 17:08
 *
 */

/**
 *日期格式化函数
 * @param date
 * @param fmt
 * @returns {*}
 */
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(52),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(53),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(33)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = saveToLocal;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadFromLocal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Author:shiduobin
 * Create Time:2017-08-26 11:57
 *
 */

/**
 * localstorage 存储 收藏商家
 * window.localStorage = __seller__
 * 存储函数 saveToLocal(id,key,value)
 * 读取函数 loadFormLocal(id,key,default)
 * @param id
 * @param key
 * @param value
 */
function saveToLocal(id, key, value) {
  var seller = window.localStorage.__seller__;
  if (!seller) {
    seller = {};
    seller[id] = {};
  } else {
    seller = JSON.parse(seller);
    if (!seller[id]) {
      seller[id] = {};
    }
  }
  seller[id][key] = value;
  window.localStorage.__seller__ = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(seller);
}

function loadFromLocal(id, key, def) {
  // def:default默认值
  var seller = window.localStorage.__seller__;
  if (!seller) {
    return def;
  }

  // es6不可多次声明同一个变量
  seller = JSON.parse(seller)[id];
  if (!seller) {
    return def;
  }
  var ret = seller[key];
  return ret || def;
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = urlParse;
/**
 * Author:shiduobin
 * Create Time:2017-08-26 11:39
 *
 */

/**
 * 解析url函数
 * @example ?id=12345&a=b
 * @returns {{id: number}}
 */
function urlParse() {
  var url = window.location.search;
  var obj = {};
  var reg = /[?&][^?&]+=[^?&]]+/g;
  var arr = url.match(reg);

  // arr=['?id=12345', '&a=b']
  if (arr) {
    arr.forEach(function (item) {
      var tempArr = item.substring(1).split('=');
      var key = tempArr[0];
      var val = tempArr[1];
      obj[key] = val;
    });
  }
  return { id: 123123 };
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_goods_goods_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_goods_goods_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_goods_goods_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ratings_ratings_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ratings_ratings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ratings_ratings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_seller_seller_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_seller_seller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_seller_seller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_style_index_css__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_style_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
var routes = [{
  path: '/',
  name: 'index',
  component: __WEBPACK_IMPORTED_MODULE_3__App___default.a,
  children: [{ path: '/goods', component: __WEBPACK_IMPORTED_MODULE_4__components_goods_goods_vue___default.a }, { path: '/ratings', component: __WEBPACK_IMPORTED_MODULE_5__components_ratings_ratings_vue___default.a }, { path: '/seller', component: __WEBPACK_IMPORTED_MODULE_6__components_seller_seller_vue___default.a }]
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  linkActiveClass: 'active',
  routes: routes
});
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: router
}).$mount('#app');
router.push('/goods');
/* harmony default export */ __webpack_exports__["default"] = (app);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_tool_until__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_json_data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_json_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_common_json_data__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      seller: {},
      id: function () {
        var queryParam = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_tool_until__["a" /* urlParse */])();
        console.log(queryParam);
        return queryParam.id;
      }()
    };
  },
  created: function created() {
    this.seller = __WEBPACK_IMPORTED_MODULE_2_common_json_data___default.a.seller;
  },

  components: {
    'v-header': __WEBPACK_IMPORTED_MODULE_0__components_header_header___default.a
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    food: {
      type: Object
    }
  },
  methods: {
    addCart: function addCart(event) {
      // 去掉自带click事件的点击
      if (!event._constructed) {
        return;
      }
      if (!this.food.count) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.food, 'count', 1);
      } else {
        this.food.count++;
      }
      // 子组件与父组件通信,向父组建传递当前dom对象
      this.$emit('add', event.target);
    },
    decreaseCart: function decreaseCart(event) {
      // 去掉自带click事件的点击
      if (!event._constructed) {
        return;
      }
      if (this.food.count) {
        this.food.count--;
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartcontrol_cartcontrol_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartcontrol_cartcontrol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cartcontrol_cartcontrol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__split_split_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__split_split_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__split_split_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ratingselect_ratingselect_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ratingselect_ratingselect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ratingselect_ratingselect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_tool_date__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var All = 0; // 全部评价
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    food: {
      type: Object
    }
  },
  data: function data() {
    return {
      showFlag: false,
      selectType: All,
      onlyContent: true,
      desc: {
        all: '全部',
        positive: '推荐',
        negative: '吐槽'
      }
    };
  },

  methods: {
    show: function show() {
      this.showFlag = true;
      this.selectType = All;
      this.onlyContent = false;
      this.$nextTick(function () {
        if (!this.scroll) {
          this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll___default.a(this.$refs.food, {
            click: true
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
    hide: function hide() {
      this.showFlag = false;
    },
    addFirst: function addFirst(event) {
      if (!event._constructed) {
        return;
      } else {
        // 子组件与父组件通信,向父组建传递当前dom对象
        this.$emit('add', event.target);
        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].set(this.food, 'count', 1);
      }
    },
    addFood: function addFood(target) {
      // 子组件与父组件通信,向父组建传递当前dom对象
      this.$emit('add', event.target);
    },
    // 子组件选择评价类别向父组件传递type值
    selectRating: function selectRating(type) {
      var _this = this;

      this.selectType = type;
      this.$nextTick(function () {
        _this.scroll.refresh();
      });
    },
    // 子组件选择是否只看内容向父组件传递onlyContent值
    toggleContent: function toggleContent() {
      var _this2 = this;

      this.onlyContent = !this.onlyContent;
      this.$nextTick(function () {
        _this2.scroll.refresh();
      });
    },
    // 需要展示的评价内容
    needShow: function needShow(type, text) {
      // 只看有内容的评价但当前数据没有内容则返回false被隐藏
      if (this.onlyContent && !text) {
        return false;
      }
      // 如果选择类型为全部则显示全部内容
      if (this.selectType === All) {
        return true;
      } else {
        // 否则选择什么类型显示什么类型的内容
        return type === this.selectType;
      }
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_tool_date__["a" /* formatDate */])(date, 'yyyy-MM-dd hh:mm');
    }
  },
  components: {
    cartcontrol: __WEBPACK_IMPORTED_MODULE_1__cartcontrol_cartcontrol_vue___default.a,
    split: __WEBPACK_IMPORTED_MODULE_2__split_split_vue___default.a,
    ratingselect: __WEBPACK_IMPORTED_MODULE_3__ratingselect_ratingselect_vue___default.a
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_json_data_json__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_json_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_json_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_better_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shopcart_shopcart_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shopcart_shopcart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shopcart_shopcart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cartcontrol_cartcontrol_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_cartcontrol_cartcontrol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_cartcontrol_cartcontrol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_food_food_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_food_food_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_food_food_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seller: {
      type: Object
    }
  },
  // 注册组件
  components: {
    shopcart: __WEBPACK_IMPORTED_MODULE_2__components_shopcart_shopcart_vue___default.a,
    cartcontrol: __WEBPACK_IMPORTED_MODULE_3__components_cartcontrol_cartcontrol_vue___default.a,
    food: __WEBPACK_IMPORTED_MODULE_4__components_food_food_vue___default.a
  },
  data: function data() {
    return {
      goods: [], // 商品信息
      listHeight: [], // 菜单列表元素
      scrolly: 0, // 食物列表滚动的高度实时计算
      seeFoodinfo: {} // 选中的商品用以查看商品详情
    };
  },
  created: function created() {
    var _this = this;

    this.goods = __WEBPACK_IMPORTED_MODULE_0__common_json_data_json___default.a.goods;
    this.$nextTick(function () {
      _this._initScroll();
      _this._calculateHeight();
    });
    this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee', 'hot'];
  },

  computed: {
    // 根据食物列表所处的位置，判断菜单的class
    currentIndex: function currentIndex() {
      for (var i = 0; i < this.listHeight.length; i++) {
        var height1 = this.listHeight[i];
        var height2 = this.listHeight[i + 1];
        if (!height2 || this.scrolly >= height1 && this.scrolly < height2) {
          return i;
        }
      }
      return 0;
    },
    // 选中的商品即购物车内的商品
    selectFoods: function selectFoods() {
      var foods = [];
      this.goods.forEach(function (good) {
        good.foods.forEach(function (food) {
          if (food.count) {
            foods.push(food);
          }
        });
      });
      return foods;
    }
  },
  methods: {
    // foodlist 的 height 的高度变化 自动触发计算属性 currentIndex的变化
    selectMenu: function selectMenu(index, event) {
      // 去掉自带click事件的点击
      if (!event._constructed) {
        return;
      }
      var foodList = this.$refs.foodWrapper.getElementsByClassName('food-list-hook');
      var el = foodList[index];
      this.foodScroll.scrollToElement(el, 300);
    },
    // 初始化 better-scroll
    _initScroll: function _initScroll() {
      var _this2 = this;

      this.menuScroll = new __WEBPACK_IMPORTED_MODULE_1_better_scroll___default.a(this.$refs.menuWrapper, {
        click: true // 允许点击
      });
      this.foodScroll = new __WEBPACK_IMPORTED_MODULE_1_better_scroll___default.a(this.$refs.foodWrapper, {
        probeType: 3, // 实时侦测滚动
        click: true
      });
      this.foodScroll.on('scroll', function (pos) {
        _this2.scrolly = Math.abs(Math.round(pos.y));
      });
    },
    // 计算菜单栏元素
    _calculateHeight: function _calculateHeight() {
      var foodList = this.$refs.foodWrapper.getElementsByClassName('food-list-hook');
      var height = 0;
      this.listHeight.push(height); // 将第一个高度放进数组
      for (var i = 0; i < foodList.length; i++) {
        var item = foodList[i];
        height += item.clientHeight; // 获取每一个food-list的高度做累加
        this.listHeight.push(height);
      }
    },
    _drop: function _drop(target) {
      // 体验优化,异步执行下落动画
      this.$nextTick(function () {
        this.$refs.shopcart.drop(target);
      });
    },
    // 子组件$emit派发而来的事件
    addFood: function addFood(target) {
      this._drop(target);
    },
    // 查看商品详情
    seeFood: function seeFood(food, event) {
      if (!event._constructed) {
        return;
      } else {
        this.seeFoodinfo = food;
        // 调用子组件的 food show 方法
        this.$refs.food.show();
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__star_star_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__star_star_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__star_star_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seller: {
      type: Object
    }
  },
  data: function data() {
    return {
      detailShow: false
    };
  },
  methods: {
    showDetail: function showDetail() {
      this.detailShow = true;
    },
    hideDetail: function hideDetail() {
      this.detailShow = false;
    }
  },
  created: function created() {
    this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
  },

  components: {
    'star': __WEBPACK_IMPORTED_MODULE_0__star_star_vue___default.a
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_star_star_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_star_star_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_star_star_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_split_split_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_split_split_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_split_split_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ratingselect_ratingselect_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ratingselect_ratingselect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ratingselect_ratingselect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tool_date__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_json_data_json__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_json_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_json_data_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var All = 0; // 全部评价

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seller: {
      type: Object
    }
  },
  data: function data() {
    return {
      ratings: [],
      selectType: All,
      onlyContent: false,
      desc: {
        all: '全部',
        positive: '推荐',
        negative: '吐槽'
      }
    };
  },

  components: {
    star: __WEBPACK_IMPORTED_MODULE_1__components_star_star_vue___default.a,
    split: __WEBPACK_IMPORTED_MODULE_2__components_split_split_vue___default.a,
    rateselect: __WEBPACK_IMPORTED_MODULE_3__components_ratingselect_ratingselect_vue___default.a
  },
  created: function created() {
    this.ratings = __WEBPACK_IMPORTED_MODULE_5__common_json_data_json___default.a.ratings;
    this.$nextTick(function () {
      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll___default.a(this.$refs.ratings, {
        click: true
      });
    });
  },

  methods: {
    // 子组件选择评价类别向父组件传递type值
    selectRating: function selectRating(type) {
      var _this = this;

      this.selectType = type;
      this.$nextTick(function () {
        _this.scroll.refresh();
      });
    },
    // 子组件选择是否只看内容向父组件传递onlyContent值
    toggleContent: function toggleContent() {
      var _this2 = this;

      this.onlyContent = !this.onlyContent;
      this.$nextTick(function () {
        _this2.scroll.refresh();
      });
    },
    // 需要展示的评价内容
    needShow: function needShow(type, text) {
      // 只看有内容的评价但当前数据没有内容则返回false被隐藏
      if (this.onlyContent && !text) {
        return false;
      }
      // 如果选择类型为全部则显示全部内容
      if (this.selectType === All) {
        return true;
      } else {
        // 否则选择什么类型显示什么类型的内容
        return type === this.selectType;
      }
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      var date = new Date(time);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_tool_date__["a" /* formatDate */])(date, 'yyyy-MM-dd hh:mm');
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 定义3个常量用来表示，组件描述内容
var Positive = 1; // 好评
var Negative = -1; // 差评
var All = 0; // 全部评价
/* harmony default export */ __webpack_exports__["default"] = ({
  // 接受父组件动态传过来的数据
  props: {
    // 评价的内容
    ratings: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 选择的类型
    selectType: {
      type: Number,
      default: All
    },
    // 只看的内容
    onlyContent: {
      type: Boolean,
      default: false // 默认FALSE查看所有的内容
    },
    // 描述
    desc: {
      type: Object,
      default: function _default() {
        return {
          all: '全部',
          positive: '满意',
          negative: '不满意'
        };
      }
    }
  },
  methods: {
    select: function select(type, event) {
      if (!event._constructed) {
        return;
      } else {
        /*
        * 不可以在子组件内,随意改变父组件传过来的值,通过$emit将子组件需要改变的值
        * 发送给父组件然后父组件再通过props传给子组件,然后view就会发生相应的改变
        */
        this.$emit('select', type);
      }
    },
    toggleContent: function toggleContent(event) {
      if (!event._constructed) {
        return;
      }
      this.$emit('onlyContent', this.onlyContent);
    }
  },
  computed: {
    positives: function positives() {
      return this.ratings.filter(function (rating) {
        return rating.rateType === Positive;
      });
    },
    nagatives: function nagatives() {
      return this.ratings.filter(function (rating) {
        return rating.rateType === Negative;
      });
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_star_star_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_star_star_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_star_star_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_split_split_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_split_split_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_split_split_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_better_scroll__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_better_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_tool_store__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seller: {
      type: Object
    }
  },
  data: function data() {
    var _this = this;

    return {
      favorite: function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_tool_store__["a" /* loadFromLocal */])(_this.seller.id, 'favorite', false);
      }()
    };
  },
  created: function created() {
    this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee', 'hot'];
  },

  components: {
    star: __WEBPACK_IMPORTED_MODULE_0__components_star_star_vue___default.a,
    split: __WEBPACK_IMPORTED_MODULE_1__components_split_split_vue___default.a
  },
  mounted: function mounted() {
    // 确保dom加载完毕后加载BScroll插件
    this.$nextTick(function () {
      this._initScroll();
      this._initPicScroll();
    });
  },
  /**
   * 必须等到seller数据,异步加载完成后,才能执行_initPicScroll方法
   * 将其方法执行放在watch对象中,当观测到seller数据,或得到之后执行 _initPicScroll 方法
   */
  watch: {
    // 当watch到seller数据生成时就可以执行_initScroll()和_initPicScroll方法
    seller: function seller() {
      this.$nextTick(function () {
        this._initScroll();
        this._initPicScroll();
      });
    }
  },
  computed: {
    favoriteText: function favoriteText() {
      return this.favorite ? '已收藏' : '未收藏';
    }
  },
  methods: {
    _initScroll: function _initScroll() {
      if (!this.scroll) {
        this.scroll = new __WEBPACK_IMPORTED_MODULE_2_better_scroll___default.a(this.$refs.seller, {
          click: true
        });
      } else {
        this.scroll.refresh();
      }
    },
    _initPicScroll: function _initPicScroll() {
      if (this.seller.pics) {
        var picWidth = 120;
        var margin = 6;
        var width = this.seller.pics.length * (picWidth + margin) - margin;
        this.$refs.picList.style.width = width + 'px';
        this.$nextTick(function () {
          if (!this.picScroll) {
            this.picScroll = new __WEBPACK_IMPORTED_MODULE_2_better_scroll___default.a(this.$refs.picWrapper, {
              scrollX: true, // 横向滚动
              eventPassthrough: 'vertical' // 允许外层竖向滚动，内层横向滚动
            });
          } else {
            this.picScroll.refresh();
          }
        });
      }
    },
    toggleFavorite: function toggleFavorite(event) {
      if (!event._constructed) {
        return;
      } else {
        this.favorite = !this.favorite;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_tool_store__["b" /* saveToLocal */])(this.seller.id, 'favorite', this.favorite);
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartcontrol_cartcontrol_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartcontrol_cartcontrol_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cartcontrol_cartcontrol_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_better_scroll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    cartcontrol: __WEBPACK_IMPORTED_MODULE_0__cartcontrol_cartcontrol_vue___default.a
  },
  props: {
    // 配送费
    deliveryPrice: {
      type: Number,
      default: 0
    },
    // 最低起送价
    minPrice: {
      type: Number,
      default: 0
    },
    // goods组件,传递选择的商品数组
    selectFoods: {
      type: Array,
      default: function _default() {
        return [{
          price: 30,
          count: 1
        }];
      }
    }
  },
  data: function data() {
    return {
      // 创建5个小球用于动画
      balls: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }],
      // 存储下落的小球
      dropBalls: [],
      // 折叠状态默认折叠
      fold: true
    };
  },
  computed: {
    // 商品总价格
    totalPrice: function totalPrice() {
      var total = 0;
      this.selectFoods.forEach(function (food) {
        total += food.price * food.count;
      });
      return total;
    },
    // 商品数量
    totalCount: function totalCount() {
      var count = 0;
      this.selectFoods.forEach(function (food) {
        count += food.count;
      });
      return count;
    },
    // 支付状态
    payDesc: function payDesc() {
      if (this.totalPrice === 0) {
        return '￥' + this.minPrice + '元起送';
      } else if (this.totalPrice < this.minPrice) {
        var diff = this.minPrice - this.totalPrice;
        return '还差￥' + diff + '元起送';
      } else {
        return '去结算';
      }
    },
    // 支付状态样式
    payClass: function payClass() {
      if (this.totalPrice < this.minPrice) {
        return 'not-enough';
      } else {
        return 'enough';
      }
    },
    // 购物车列表
    listShow: function listShow() {
      if (!this.totalCount) {
        this.fold = true;
        return false;
      } else {
        var show = !this.fold;
        if (show) {
          this.$nextTick(function () {
            if (!this.scroll) {
              this.scroll = new __WEBPACK_IMPORTED_MODULE_1_better_scroll___default.a(this.$refs.listContent, {
                click: true
              });
            } else {
              this.scroll.refresh();
            }
          });
        }
        return show;
      }
    }
  },
  methods: {
    // 折叠购物车列表
    toggleList: function toggleList() {
      if (!this.totalCount) {
        return;
      }
      this.fold = !this.fold;
    },
    // 清空购物车
    empty: function empty() {
      this.selectFoods.forEach(function (food) {
        food.count = 0;
      });
    },
    // 点击背景折叠购物车
    hideList: function hideList() {
      this.fold = !this.fold;
    },
    // 支付
    pay: function pay() {
      if (this.totalPrice < this.minPrice) {
        return;
      } else {
        var money = this.totalPrice + this.deliveryPrice;
        window.alert('支付' + money + '元');
      }
    },
    drop: function drop(el) {
      for (var i = 0; i < this.balls.length; i++) {
        var ball = this.balls[i];
        if (!ball.show) {
          ball.show = true;
          ball.el = el;
          this.dropBalls.push(ball);
          return;
        }
      }
    },
    beforeDrop: function beforeDrop(el) {
      var count = this.balls.length;
      while (count--) {
        var ball = this.balls[count];
        if (ball.show) {
          var rect = ball.el.getBoundingClientRect(); // 获取对象距离当前视图窗口的距离:top,right,bottom,left
          var x = rect.left - 32; // 购物小球X轴的位置
          var y = -(window.innerHeight - rect.top - 22); // 购物小球Y轴的位置
          el.style.display = '';
          // 纵向动画 el(初始位置为 0，0，0)和购物车icon在一起,将小球(el)放到加号位置去
          el.style.webkitTransform = 'translate3d(0,' + y + 'px,0)';
          el.style.transform = 'translate3d(0,' + y + 'px,0)';
          // 横向动画  inner-hook,仅仅定义类 dom选择器,不做样式
          var inner = el.getElementsByClassName('inner-hook')[0];
          inner.style.webkitTransform = 'translate3d(' + x + 'px,0,0)';
          inner.style.transform = 'translate3d(' + x + 'px,0,0)';
        }
      }
    },
    dropping: function dropping(el) {
      // 手动触发浏览器重绘,便于translate3d,--rf 变量不会使用
      /* eslint-disable no-unused-vars */
      var rf = el.offsetHeight;
      this.$nextTick(function () {
        // 重置小球样式位置，置于购物车按钮位置处
        el.style.webkitTransform = 'translate3d(0,0,0)';
        el.style.transform = 'translate3d(0,0,0)';
        var inner = el.getElementsByClassName('inner-hook')[0];
        inner.style.webkitTransform = 'translate3d(0,0,0)';
        inner.style.transform = 'translate3d(0,0,0)';
      });
    },
    afterDrop: function afterDrop(el) {
      // 此轮动画结束后,将此次的ball取出,ball状态重置,进行重用
      var ball = this.dropBalls.shift();
      if (ball) {
        ball.show = false;
        el.style.display = 'none';
      }
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

var length = 5;
var classOn = 'on';
var classHalf = 'half';
var classOff = 'off';
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      type: Number
    },
    score: {
      type: Number
    }
  },
  computed: {
    starType: function starType() {
      return 'star-' + this.size;
    },
    itemClasses: function itemClasses() {
      var result = [];
      var score = Math.floor(this.score * 2) / 2;
      var hasDecimal = score % 1 !== 0;
      var integer = Math.floor(score);
      for (var i = 0; i < integer; i++) {
        result.push(classOn);
      }
      if (hasDecimal) {
        result.push(classHalf);
      }
      while (result.length < length) {
        result.push(classOff);
      }
      return result;
    }
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(54),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(50),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "ratings",
    staticClass: "ratings"
  }, [_c('div', {
    staticClass: "ratings-content"
  }, [_c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "overview-left"
  }, [_c('h1', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.seller.score))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("综合评分")]), _vm._v(" "), _c('div', {
    staticClass: "rank"
  }, [_vm._v("高于周边商家" + _vm._s(_vm.seller.rankRate) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "overview-right"
  }, [_c('div', {
    staticClass: "score-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("服务态度")]), _vm._v(" "), _c('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.serviceScore
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.seller.serviceScore))])], 1), _vm._v(" "), _c('div', {
    staticClass: "score-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("商品评分")]), _vm._v(" "), _c('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.foodScore
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.seller.foodScore))])], 1), _vm._v(" "), _c('div', {
    staticClass: "delivery-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("送达时间")]), _vm._v(" "), _c('span', {
    staticClass: "delivery"
  }, [_vm._v(_vm._s(_vm.seller.deliveryTime) + "分钟")])])])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('rateselect', {
    attrs: {
      "desc": _vm.desc,
      "ratings": _vm.ratings,
      "selectType": _vm.selectType,
      "onlyContent": _vm.onlyContent
    },
    on: {
      "select": _vm.selectRating,
      "onlyContent": _vm.toggleContent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ratings-wrapper"
  }, [_c('ul', _vm._l((_vm.ratings), function(rating) {
    return (_vm.needShow(rating.rateType, rating.text)) ? _c('li', {
      staticClass: "rating-item"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": rating.avatar,
        "width": "28",
        "height": "28",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(rating.username))]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('star', {
      attrs: {
        "size": 24,
        "score": rating.score
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(rating.deliveryTime) + "分钟送达")])], 1), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(rating.text))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (rating.recommend && rating.recommend.length),
        expression: "rating.recommend && rating.recommend.length"
      }],
      staticClass: "recommend"
    }, [_c('span', {
      staticClass: "icon-thumb_up icon-font"
    }), _vm._v(" "), _vm._l((rating.recommend), function(item) {
      return _c('span', {
        staticClass: "item"
      }, [_vm._v(_vm._s(item))])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n              " + _vm._s(_vm._f("formatDate")(rating.rateTime)) + "\n            ")])])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("已经到底啦")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])
}]}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split"
  })
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "seller",
    staticClass: "seller"
  }, [_c('div', {
    staticClass: "seller-content"
  }, [_c('div', {
    staticClass: "overview"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "desc border-1px"
  }, [_c('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.score
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("(" + _vm._s(_vm.seller.ratingCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("月售" + _vm._s(_vm.seller.sellCount) + "单")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "remark"
  }, [_c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("起送价")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.minPrice))]), _vm._v("元\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商家配送")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.deliveryPrice))]), _vm._v("元\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("平均配送时间")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.deliveryTime))]), _vm._v("分钟\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "favorite",
    on: {
      "click": function($event) {
        _vm.toggleFavorite($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-favorite",
    class: {
      'active': _vm.favorite
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.favoriteText))])])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "bulletin"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("公告与活动")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])]), _vm._v(" "), (_vm.seller.supports) ? _c('ul', {
    staticClass: "support"
  }, _vm._l((_vm.seller.supports), function(item, index) {
    return _c('li', {
      staticClass: "support-item"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(_vm.seller.supports[index].description) + " ")])])
  })) : _vm._e()]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "pics"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商家实景")]), _vm._v(" "), _c('div', {
    ref: "picWrapper",
    staticClass: "picwrapper"
  }, [_c('ul', {
    ref: "picList",
    staticClass: "pic-list"
  }, _vm._l((_vm.seller.pics), function(pic) {
    return _c('li', {
      staticClass: "pic-item"
    }, [_c('img', {
      attrs: {
        "width": "120",
        "height": "90",
        "src": pic,
        "alt": ""
      }
    })])
  }))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "title border-1px"
  }, [_vm._v("商家信息")]), _vm._v(" "), _c('ul', _vm._l((_vm.seller.infos), function(info) {
    return _c('li', {
      staticClass: "info-item"
    }, [_vm._v(_vm._s(info))])
  }))]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("已经到底啦")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])
}]}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "width": "64",
      "height": "64",
      "src": _vm.seller.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "brand"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))])]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.seller.description) + "·约" + _vm._s(_vm.seller.deliveryTime) + "分钟送达\n      ")]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "support"
  }, [_c('span', {
    staticClass: "icon",
    class: _vm.classMap[_vm.seller.supports[0].type]
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.supports[0].description))])]) : _vm._e()]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "support-count",
    on: {
      "click": _vm.showDetail
    }
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.seller.supports.length) + "个")]), _c('span', {
    staticClass: "icon-font icon-keyboard_arrow_right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulletin-wrapper",
    on: {
      "click": _vm.showDetail
    }
  }, [_c('span', {
    staticClass: "bulletin-title"
  }), _c('span', {
    staticClass: "bulletin-text"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))]), _vm._v(" "), _c('i', {
    staticClass: "icon-font icon-keyboard_arrow_right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": _vm.seller.avatar,
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailShow),
      expression: "detailShow"
    }],
    staticClass: "detail",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "detail-wrapper clearfix"
  }, [_c('div', {
    staticClass: "detail-main"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "star-wrapper"
  }, [_c('star', {
    attrs: {
      "size": 48,
      "score": _vm.seller.score
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("优惠信息")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), (_vm.seller.supports) ? _c('ul', {
    staticClass: "supports"
  }, _vm._l((_vm.seller.supports), function(item, index) {
    return _c('li', {
      staticClass: "supports-item"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.seller.supports[index].description))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("商家公告")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bulletin"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-close"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": _vm.hideDetail
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cartcontrol"
  }, [_c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.count > 0),
      expression: "food.count>0"
    }],
    staticClass: "cart-decrease",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.decreaseCart($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-remove_circle_outline inner"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.count),
      expression: "food.count"
    }],
    staticClass: "cart-count"
  }, [_vm._v("\n    " + _vm._s(_vm.food.count) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "cart-add",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addCart($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-add_circle"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratingselect"
  }, [_c('div', {
    staticClass: "rating-type"
  }, [_c('span', {
    staticClass: "block all",
    class: {
      'active': _vm.selectType === 0
    },
    on: {
      "click": function($event) {
        _vm.select(0, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.desc.all)), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.ratings.length) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "block positive",
    class: {
      'active': _vm.selectType === 1
    },
    on: {
      "click": function($event) {
        _vm.select(1, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.desc.positive)), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.positives.length) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "block negative",
    class: {
      'active': _vm.selectType === -1
    },
    on: {
      "click": function($event) {
        _vm.select(-1, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.desc.negative)), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.nagatives.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      'on': _vm.onlyContent
    },
    on: {
      "click": _vm.toggleContent
    }
  }, [_c('span', {
    staticClass: "icon-check_circle icon-font"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("只看有内容的评价")])])])
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item, index) {
    return _c('li', {
      staticClass: "menu-item",
      class: {
        'current': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectMenu(index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "text border-1px"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type > 0),
        expression: "item.type>0"
      }],
      staticClass: "icon",
      class: _vm.classMap[item.type]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])])
  }))]), _vm._v(" "), _c('div', {
    ref: "foodWrapper",
    staticClass: "foods-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item) {
    return _c('li', {
      staticClass: "food-list food-list-hook"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.foods), function(food) {
      return _c('li', {
        staticClass: "food-item border-1px",
        on: {
          "click": function($event) {
            _vm.seeFood(food, $event)
          }
        }
      }, [_c('div', {
        staticClass: "img-icon"
      }, [_c('img', {
        attrs: {
          "src": food.icon,
          "width": "64",
          "height": "64"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(food.name))]), _vm._v(" "), (food.remark) ? _c('span', {
        staticClass: "remark"
      }, [_vm._v("(" + _vm._s(food.remark) + ")")]) : _vm._e(), _vm._v(" "), (food.description) ? _c('div', {
        staticClass: "describe"
      }, [_c('p', {
        staticClass: "desc"
      }, [_vm._v(_vm._s(food.description))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "extra"
      }, [_c('span', {
        staticClass: "count"
      }, [_vm._v("月售" + _vm._s(food.sellCount))]), _c('span', [_vm._v("好评率" + _vm._s(food.rating) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "price"
      }, [_c('span', {
        staticClass: "now"
      }, [_c('span', {
        staticClass: "icon-font"
      }, [_vm._v("￥")]), _vm._v(_vm._s(food.price))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "old"
      }, [_vm._v("￥" + _vm._s(food.oldPrice))])]), _vm._v(" "), _c('div', {
        staticClass: "cartcontrol-wrapper"
      }, [_c('cartcontrol', {
        attrs: {
          "food": food
        },
        on: {
          "add": _vm.addFood
        }
      })], 1)])])
    }))])
  }))]), _vm._v(" "), _c('shopcart', {
    ref: "shopcart",
    attrs: {
      "delivery-price": _vm.seller.deliveryPrice,
      "min-price": _vm.seller.minPrice,
      "select-foods": _vm.selectFoods
    }
  }), _vm._v(" "), _c('food', {
    ref: "food",
    attrs: {
      "food": _vm.seeFoodinfo
    },
    on: {
      "add": _vm.addFood
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "food",
    staticClass: "food"
  }, [_c('div', {
    staticClass: "food-content"
  }, [_c('div', {
    staticClass: "image-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.food.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-arrow_lift icon-font"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.food.name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "sell-count"
  }, [_vm._v("月售" + _vm._s(_vm.food.sellCount) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "rating"
  }, [_vm._v("好评率" + _vm._s(_vm.food.rating) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v("￥" + _vm._s(_vm.food.price))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "old"
  }, [_vm._v("￥" + _vm._s(_vm.food.oldPrice))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.count > 0),
      expression: "food.count>0"
    }],
    staticClass: "cartcontrol-wrapper"
  }, [_c('cartcontrol', {
    attrs: {
      "food": _vm.food
    },
    on: {
      "add": _vm.addFood
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.count || _vm.food.count === 0),
      expression: "!food.count||food.count===0"
    }],
    staticClass: "buy",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addFirst($event)
      }
    }
  }, [_vm._v("加入购物车")])])], 1), _vm._v(" "), _c('split', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }],
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.food.info))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "rating"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品评价")]), _vm._v(" "), _c('ratingselect', {
    attrs: {
      "selectType": _vm.selectType,
      "onlyContent": _vm.onlyContent,
      "desc": _vm.desc,
      "ratings": _vm.food.ratings
    },
    on: {
      "select": _vm.selectRating,
      "onlyContent": _vm.toggleContent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.ratings && _vm.food.ratings.length),
      expression: "food.ratings && food.ratings.length"
    }]
  }, _vm._l((_vm.food.ratings), function(rating) {
    return (_vm.needShow(rating.rateType, rating.text)) ? _c('li', {
      staticClass: "rating-item border-1px"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(rating.username))]), _vm._v(" "), _c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "12",
        "height": "12",
        "src": rating.avatar,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(rating.rateTime)))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_c('i', {
      staticClass: "icon-font",
      class: {
        'icon-thumb_up': rating.rateType === 1, 'icon-thumb_down': rating.rateType === -1
      }
    }), _vm._v("\n                " + _vm._s(rating.text) + "\n              ")])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.ratings || !_vm.food.ratings.length),
      expression: "!food.ratings||!food.ratings.length"
    }],
    staticClass: "no-rating"
  }, [_vm._v("\n            暂无评价\n          ")])])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "shopcart"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        _vm.toggleList($event)
      }
    }
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "logo",
    class: {
      'highlight': _vm.totalCount > 0
    }
  }, [_c('i', {
    staticClass: "icon-shopping_cart icon-font",
    class: {
      'highlight': _vm.totalCount > 0
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount>0"
    }],
    staticClass: "num"
  }, [_vm._v("\n            " + _vm._s(_vm.totalCount) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: {
      'highlight': _vm.totalPrice > 0
    }
  }, [_vm._v("￥" + _vm._s(_vm.totalPrice) + "元")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("另需配送费￥" + _vm._s(_vm.deliveryPrice) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "content-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.pay($event)
      }
    }
  }, [_c('div', {
    staticClass: "pay",
    class: _vm.payClass
  }, [_vm._v("\n          " + _vm._s(_vm.payDesc) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ball-container"
  }, _vm._l((_vm.balls), function(ball) {
    return _c('div', [_c('transition', {
      on: {
        "before-enter": _vm.beforeDrop,
        "enter": _vm.dropping,
        "after-enter": _vm.afterDrop
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (ball.show),
        expression: "ball.show"
      }],
      staticClass: "ball"
    }, [_c('div', {
      staticClass: "inner inner-hook"
    })])])], 1)
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fold"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listShow),
      expression: "listShow"
    }],
    staticClass: "shopcart-list"
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('span', {
    staticClass: "empty",
    on: {
      "click": _vm.empty
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    ref: "listContent",
    staticClass: "list-content"
  }, [_c('ul', _vm._l((_vm.selectFoods), function(food) {
    return _c('li', {
      staticClass: "food"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(food.name))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v("￥" + _vm._s(food.price * food.count))])]), _vm._v(" "), _c('div', {
      staticClass: "cartcontrol-wrapper"
    }, [_c('cartcontrol', {
      attrs: {
        "food": food
      }
    })], 1)])
  }))])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listShow),
      expression: "listShow"
    }],
    staticClass: "list-mask",
    on: {
      "click": _vm.hideList
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star",
    class: _vm.starType
  }, _vm._l((_vm.itemClasses), function(itemClass, index) {
    return _c('span', {
      key: index,
      staticClass: "star-item",
      class: itemClass
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header', {
    attrs: {
      "seller": _vm.seller
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab border-1px"
  }, [_c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": '/goods'
    }
  }, [_vm._v("\n        商品\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/ratings"
    }
  }, [_vm._v("\n        评论\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/seller"
    }
  }, [_vm._v("\n        商家\n      ")])], 1)]), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "seller": _vm.seller
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[18]);


// WEBPACK FOOTER //
// static/tool/app.a0416415b7093d43713c.js